const ProductTHead1 = ({ title1, title2, title3 }) => {
  return (
    <thead>
      <tr className="text-center">
        <th scope="col">
          <span className="fs-eight">{title1}</span>
        </th>
        <th scope="col">
          <span className="fs-eight">{title2}</span>
        </th>
        <th scope="col">
          <span className="fs-eight">{title3}</span>
        </th>
      </tr>
    </thead>
  );
};

export default ProductTHead1;
